export const getThemeColorByColorTxt = (colorTxt: string, themeColor: any): string => {
  const colorLayer = colorTxt.split('.')

  return colorLayer.length > 1 ? themeColor[colorLayer[0]][colorLayer[1]] : ''
}
